export default "__VITE_ASSET__CWxvGS$e__"